import Link from 'next/link';

import styles from './Breadcrumbs.module.scss';

interface Props {
  items: Array<[string, string] | string>;
}

const Breadcrumbs: React.FC<Props> = ({ items }) => {
  return (
    <ul className={styles.breadcrumbs}>
      {items.map((item, inx) => (
        <li key={inx}>
          {typeof item === 'string' ? (
            item
          ) : (
            <Link href={item[1]}>
              <a>{item[0]}</a>
            </Link>
          )}
        </li>
      ))}
    </ul>
  );
};

export default Breadcrumbs;
